import createMrktHomeCardImpressionBrowser from 'spotify-event-definitions/events/createMrktHomeCardImpressionBrowser';
import createMrktHomeCardInteractionBrowser from 'spotify-event-definitions/events/createMrktHomeCardInteractionBrowser';
import { logGabitoEvent, PageId } from '../PlatformEvents';
import { useCurrentOrgOrNull } from '../../features/artists/src/useCurrentOrgOrNull';

export type HomeCardEvent = {
  card_id: string;
  card_source: string;
  target: string;
  page_id: string;
  page_uri: string;
  creator_uri: string;
  organization_uri: string;
  notification_class: string;
};

export type HomeTracker = {
  makeHomeCardEvent: (
    cardId: string,
    cardSource: string,
    target: string,
    creatorUri: string,
    notificationClass: string,
  ) => HomeCardEvent;
  trackImpression: (event: HomeCardEvent) => void;
  trackInteraction: (event: HomeCardEvent) => void;
};

export const useHomeTracker = (): HomeTracker => {
  const currentOrgOrNull = useCurrentOrgOrNull();
  const orgUri = currentOrgOrNull ? currentOrgOrNull.uri : '';

  return {
    makeHomeCardEvent: (
      cardId,
      cardSource,
      target,
      creatorUri,
      notificationClass,
    ) => {
      return {
        card_id: cardId,
        card_source:
          cardSource === 'UNRECOGNIZED' || cardSource === 'UNKNOWN'
            ? 'UNKNOWN_TYPE'
            : cardSource,
        target,
        page_id: PageId.ArtistHome,
        page_uri: window.location.href,
        creator_uri: creatorUri,
        organization_uri: orgUri,
        notification_class: notificationClass,
      };
    },
    trackImpression: event => {
      logGabitoEvent(createMrktHomeCardImpressionBrowser(event));
    },
    trackInteraction: event => {
      logGabitoEvent(createMrktHomeCardInteractionBrowser(event));
    },
  };
};
